export const name = 'Programs';

export const AUTHORIZATION_TASK_DEFINITION_ID =
  'D61AD95C-2447-4209-B10A-C65B5BCC303F';
export const APPROVED_TASK_DEFINITION_ID =
  '484C994F-62B3-4B02-8809-A403EDFDD6B6';
export const REFERRAL_AUTHORIZATION_TASK_DEFINITION_ID =
  '12AB325E-AE57-4DC6-BD72-347640CFC107';

export const programStatus = {
  all: 'All',
  draft: 'Draft',
  pending: 'PendingApproval',
  uwapproved: 'UnderwriterApproved',
  approved: 'Approved',
  inprogress: 'InProgress',
  bound: 'Bound',
  declinedNotTaken: 'ClosedAndNonRenewed',
};
export const programStatusOptions = [
  {
    value: 'Draft',
    label: 'Draft',
  },
  {
    value: 'InProgress',
    label: 'InProgress',
  },
  {
    value: 'Bound',
    label: 'Bound',
  },
  {
    value: 'Approved',
    label: 'Approved',
  },
  {
    value: 'Declined',
    label: 'Declined',
  },
  {
    value: 'NotTaken',
    label: 'Not Taken',
  },
];

export const programViewBy = [
  { value: 'Programs', label: 'Programs' },
  { value: 'Parent Company', label: 'Parent Company' },
];

export const nextStatus = {
  create: programStatus.draft,
  Draft: 'CompleteDraft',
  PendingApproval: programStatus.uwapproved,
  underwriterapproved: programStatus.uwapproved,
  UnderwriterApproved: programStatus.approved,
  approved: programStatus.approved,
  Approved: programStatus.approved,
};

export const previousStatus = {
  PendingApproval: programStatus.draft,
  underwriterapproved: programStatus.pending,
  UnderwriterApproved: programStatus.pending,
  approved: programStatus.uwapproved,
  Approved: programStatus.uwapproved,
};

export const optionsDirectBroker = [
  { value: 'Direct', label: 'Direct' },
  { value: 'Broker', label: 'Broker' },
];

export const optionsPaperSeparationType = [
  { value: 'ByLayer', label: 'Layer' },
  { value: 'ByPolicy', label: 'Policy' },
];

export const optionsMaximumEO = [
  { value: 'ThirtyDays', label: '30' },
  { value: 'SixtyDays', label: '60' },
  { value: 'NinetyDays', label: '90' },
  { value: 'HundredAndTwentyDays', label: '120' },
  { value: 'Other', label: 'other' },
];

export const optionsProgramType = [
  { value: 'BDX', label: 'BDX' },
  { value: 'BDXBindingAgreement', label: 'BDX Binding Agreement' },
  { value: 'PortalBindingAgreement', label: 'Portal Binding Agreement' },
  { value: 'Portal', label: 'Portal' },
  { value: 'IRThroughArchway', label: 'IR Through Archway' },
];

export const optionsRevisionLayer = [
  { value: 'SingleLayer', label: 'Single Layer' },
  {
    value: 'MultiLayerSinglePurchase',
    label: 'Multi Layer - single purchase',
  },
  { value: 'MultiLayerOptions', label: 'Multi Layer - options' },
];

export const optionsRevisionMultiLocation = [
  { value: 'Scheduled', label: 'Scheduled' },
  // { value: 'blanket', label: 'Blanket' },
  { value: 'NotApplicable', label: 'Not Applicable' },
];

export const optionsRiskAttachement = [
  { value: 'RisksAttaching', label: 'Risk attaching' },
  { value: 'LossesOccurring', label: 'Losses occurring' },
];

export const optionsCatBasis = [
  { value: 'PerRisk', label: 'Per risk' },
  { value: 'PerOccurrence', label: 'Per occurrence' },
];

export const optionsCappedByCession = [
  { value: 'Y', label: 'Yes' },
  { value: 'N', label: 'No' },
  { value: 'Silent', label: 'Silent' },
  { value: 'NA', label: 'N/A' },
];

export const optionsCyberExclusion = [
  { value: 'Silent', label: 'Silent' },
  { value: 'NMA2928', label: 'NMA2928' },
  { value: 'NMA2915', label: 'NMA2915' },
  {
    value: 'ExcludedResultingPerilsWording',
    label: 'Excluded - Resulting Perils Wording',
  },
  { value: 'ExcludedEntirely', label: 'Excluded Entirely' },
  { value: 'Other', label: 'Other' },
];

export const optionsVirusExclusion = [
  { value: 'LMA5393', label: 'Communicable Disease as per LMA 5393' },
  { value: 'LMA5394', label: 'Communicable Disease as per LMA 5394' },
  { value: 'LMA5391', label: 'Coronavirus as per LMA 5391' },
];

export const optionsDeclaratoryJudgement = [
  { value: 'I', label: 'Included' },
  { value: 'NI', label: 'Not Included' },
  { value: 'SL', label: 'Silent' },
  { value: 'NA', label: 'N/A' },
];

export const optionsLAE = [
  { value: 'IU', label: 'Included ultimate (in ultimate net loss)' },
  { value: 'IA', label: 'In addition to' },
  { value: 'NA', label: 'N/A' },
];

export const optionsECO = [
  { value: 'I', label: 'Included' },
  { value: 'NI', label: 'Not Included' },
  { value: 'NA', label: 'N/A' },
];

export const optionsLEPL = [
  { value: 'I', label: 'Included' },
  { value: 'NI', label: 'Not Included' },
  { value: 'NA', label: 'N/A' },
];

export const optionsSpecTermination = [
  { value: 'N', label: 'No' },
  { value: 'YCR', label: 'Yes - Capital Reduction' },
  { value: 'TRG', label: 'Trigger' },
  { value: 'YDT', label: 'Yes - Downgrade Trigger' },
  { value: 'YNT', label: 'Yes - No Trigger' },
  { value: 'YOT', label: 'Yes - Other' },
  { value: 'NA', label: 'N/A' },
];

export const optionsFloodZones = [
  { value: 'A', label: 'A' },
  { value: 'AV', label: 'A & V' },
  { value: 'B', label: 'B' },
  { value: 'AB', label: 'A & B' },
  { value: 'ABV', label: 'A, B & V' },
  { value: 'V', label: 'V' },
  { value: 'Other', label: 'Other' },
];

export const optionsPricingApproach = [
  { value: 'XsRate', label: 'Xs Rates' },
  { value: 'PercentageOfPremium', label: '% of Premium' },
  { value: 'PercentageOfTiv', label: '% of TIV' },
  {
    value: 'PercentageOfPremiumDistributionScale',
    label: '% of Premium with curve',
  },
  { value: 'Flat', label: 'Flat' },
  { value: 'CompositeRateAgainstExposure', label: 'CRE' },
  { value: 'Other', label: 'Other' },
];

export const optionsTerrorismType = [
  { value: 'OneBillionDollars', label: '$1B' },
  { value: 'OneHundredMillionDollars', label: '$100M' },
  { value: 'FiveHundredMillionDollars', label: '$500M' },
  { value: 'OTHTHRESH', label: 'Other Threshold' },
  { value: 'EXCLNMA', label: 'Excluded Entirely - NMA' },
  { value: 'EXCLOTH', label: 'Excluded Entirely - Other' },
  { value: 'INCEXNBCR', label: 'Included, Ex NBCR' },
  { value: 'INCWNBCR', label: 'Included, Incl NBCR' },
  { value: 'CANOneHundredMillionDollarsThresh', label: 'CAN$100M Threshold' },
  { value: 'CANOneBillionDollarsThresh', label: 'CAN$1B Threshold' },
  { value: 'EXNBCRANDFF', label: 'EX NBCR&FF' },
  { value: 'EXNR', label: 'EX NR' },
  { value: 'EXNRANDFF', label: 'EXNR&FF' },
  { value: 'GAREAT', label: 'Gareat' },
  { value: 'OTHER', label: 'Other' },
];

export const optionsFireTerrorismType = [
  { value: 'EXPLEXCL', label: 'Explicitly Excluded' },
  { value: 'INCLSPF', label: 'Included, SFP states only' },
  { value: 'INCLALLST', label: 'Included, all states' },
  { value: 'SILEXCLS', label: 'Silent, deemed Excluded (strong)' },
  { value: 'SILEXCLM', label: 'Silent, deemed Excluded (moderate)' },
  { value: 'SILEXCLO', label: 'Silent, deemed Excluded (other)' },
];

export const optionsClientPremium = [
  { value: 'NetOnly', label: 'Net only' },
  {
    value: 'GrossOnly',
    label: 'Gross only',
  },
  {
    value: 'Both',
    label: 'Both Net and Gross',
  },
];

export const billingOccurrenceOptions = [
  {
    value: 'Monthly',
    label: 'Monthly',
  },
  {
    value: 'Quarterly',
    label: 'Quarterly',
  },
  {
    value: 'Annually',
    label: 'Yearly',
  },
];

export const DeclineNotTakenReasons = [
  {
    label: 'None',
    value: 'None',
  },
  {
    label: 'Client Or Broker Lost',
    value: 'ClientOrBrokerLost',
  },
  {
    label: 'Price',
    value: 'Price',
  },
  {
    label: 'Relationship',
    value: 'Relationship',
  },
  {
    label: 'Kept Net/Treaty Layer',
    value: 'KeptNetTreatyLayer',
  },
  {
    label: 'Kept Fac',
    value: 'KeptFac',
  },
  {
    label: 'Stayed With Incumbent',
    value: 'StayedWithIncumbent',
  },
  {
    label: 'Loss History',
    value: 'LossHistory',
  },
  {
    label: 'Wildfire',
    value: 'Wildfire',
  },
  {
    label: 'Hurricane',
    value: 'HU',
  },
  {
    label: 'Earthquake',
    value: 'EQ',
  },
  {
    label: 'Attachment Point',
    value: 'AttachmentPoint',
  },
  {
    label: 'Terrorism',
    value: 'Terrorism',
  },
  {
    label: 'Layer',
    value: 'Layer',
  },
];

export const publishLiveStatus = {
  unpublished: 'Unpublished',
  internalPublished: 'InternalPublished',
  fullPublished: 'FullPublished',
};

export const optionsCompanyType = [
  { value: 'Canada', label: 'Canada' },
  { value: 'EAndS', label: 'E&S' },
  { value: 'Europe', label: 'Europe' },
  { value: 'Florida', label: 'Florida' },
  { value: 'InlandMarine', label: 'Inland Marine' },
  { value: 'LargeAdmitted', label: 'Large Admitted' },
  { value: 'MGA', label: 'MGA' },
  { value: 'RegionalMutual', label: 'Regional/Mutual' },
];

export const optionsSubCoOccupancy = [
  { value: 'DOL', label: 'DOL' },
  { value: 'EAndS', label: 'E&S' },
  { value: 'FarmOwner', label: 'Farm Owner' },
  { value: 'Habitational', label: 'Habitational' },
  { value: 'HighExcessAutoFac', label: 'High Excess AutoFac' },
  { value: 'IRThroughArchway', label: 'IR Through Archway' },
  { value: 'MiddleMarket', label: 'Middle Market' },
  { value: 'Municipality', label: 'Municipality' },
  { value: 'NamedPerilFlood', label: 'Named Peril - Flood' },
  { value: 'NamedPerilWildfire', label: 'Named Peril - Wildfire' },
  { value: 'NamedPerilWind', label: 'Named Peril - Wind' },
  { value: 'SuperRegional', label: 'Super Regional' },
];
